import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

// Navbar dropdown menu content. The property `variant` is used to style the links differently (see \src\components\header\MenuLinksDropDown.tsx)
export const navbarMenuItems: any = [
  {
    label: "ParkServe Home",
    url: "https://www.tpl.org/parkserve/",
    variant: "link",
  },
  {
    label: "User Survey",
    url: "https://forms.office.com/Pages/ResponsePage.aspx?id=9x1lwrv2vUeHLSNtw8bZ4GnV2FURkExJoeIgNf34JHFUNUxLN1owQzNVNzJETlZIUkFGOFQwRUdaTS4u",
    variant: "link",
  },
  {
    label: "Data Downloads",
    url: "https://www.tpl.org/park-data-downloads",
    variant: "link",
  },
  {
    label: "Data and Methods Description",
    url: "https://www.tpl.org/parkserve/about",
    variant: "link",
  },
  {
    label: "ParkScore® Index",
    url: "https://www.tpl.org/parkscore",
    variant: "link",
  },
  {
    label: "Edit Your Park Data",
    url: "#",
    variant: "link",
  },
  {
    label:
      "For general comments and questions, please email ParkServe.Manage@tpl.org",
    url: "mailto:ParkServe.Manage@tpl.org",
    variant: null,
  },
];

interface Services {
    [key: string]: any; // Allows any string key with any value type
}

let stage = "dev";
const services: Services = {
    dev: {
        webMapId: "da3a415b54a745c5a8439ae788b54569",
        fsMainUrl: "https://server6.tplgis.org/arcgis6/rest/services/ParkServeDev/ParkServe_DevWeb_Pg/FeatureServer",
        fsOverlaysUrl: "https://server6.tplgis.org/arcgis6/rest/services/ParkServeDev/ParkServe_DevOverlays26Pg/FeatureServer",
        gpEvaluatorUrl: "https://server6.tplgis.org/arcgis6/rest/services/ParkServeDev/EvaluatorSummary_DevBp/GPServer/EvaluatorSummaryProd",
        gpReportUrl: "https://server6.tplgis.org/arcgis6/rest/services/ParkServeDev/ImpactReportDevPro/GPServer/ImpactReportDevPro",
        mapExportUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_ExportWebMap/GPServer/Export%20Web%20Map"
    },
    prod: {
        webMapId: "b4861d3abd5d4f3e9ef9a08c4cf96a42",
        fsMainUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_ProdNew/FeatureServer",
        fsOverlaysUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_ProdOverlays26/FeatureServer",
        gpEvaluatorUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_EvaluatorSummaryProd/GPServer/EvaluatorSummaryProd",
        gpReportUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_EvaluatorReportProd/GPServer/EvaluatorReportProd",
        mapExportUrl: "https://server7.tplgis.org/arcgis7/rest/services/ParkServe/ParkServe_ExportWebMap/GPServer/Export%20Web%20Map"
    }

}
// web map
export const mapId = services[stage]['webMapId']

// web map layer IDs
export const parkLayerId = "ParkServe_DevNew_414";
export const parkServiceLayerId = "ParkServe_DevNew_8791";
export const parkServePlaceLayerId = "187bf33264a-layer-41";
export const parkServeUrbanLayerId = "187bf2fdfd8-layer-40";
export const priorityAreaUrbanFLId = "18338cf4830-layer-38";
export const priorityAreaPlaceFLId = "ParkServe_DevNew_3123";
export const prioritizeLayerId = "prioritize";

// main feature serice layer urls
export const urbanAreaURL = `${services[stage].fsMainUrl}/0`;
export const placeServiceURL = `${services[stage].fsMainUrl}/1`;

export const statsServiceURL = `${services[stage].fsMainUrl}/4`;

// GP service url
export const gpURL = services[stage].gpEvaluatorUrl;
export const gpPDF_URL = services[stage].gpReportUrl;
export const mapExportURL = services[stage].mapExportUrl;

interface Fields {
    [key: string]: any; // Allows any string key with any value type
}

// Used to crosswalk field names if when services change
export const dataFields: Fields = {
    OBJECTID: "objectid",
    BG_Count: "bg_count",
    ID: "id",
    Largest_Park_Acreage: "largest_park_acreage",
    Largest_Park_Name: "largest_park_name",
    Median_Park_Size: "median_park_size",
    NAME: "name",
    NAME_SPLIT: "name_split",
    Name: "name",
    Park_Count: "park_count",
    ParkScore: "parkscore",
    ParkServe_UrbanArea_ID: "parkserve_urbanarea_id",
    ParkServe_UrbanArea_IDLong: "parkserve_urbanarea_idlong",
    ParkServe_UrbanArea_Name: "parkserve_urbanarea_name",
    PercServed2022: "percserved2022",
    PercServed2023: "percserved2023",
    PL_TYPE: "pl_type",
    PLACE_ID: "place_id",
    Place_StAbbrev: "place_stabbrev",
    PlaceID: "placeid",
    ST_ABBREV: "st_abbrev",
    STATE_NAME: "state_name",
    SUM_AMERIND: "sum_amerind",
    SUM_AMERINDSVC: "sum_amerindsvc",
    SUM_ASIAN: "sum_asian",
    SUM_ASIAN_SVC: "sum_asian_svc",
    SUM_BGAREA: "sum_bgarea",
    SUM_BLACK: "sum_black",
    SUM_BLACK_SVC: "sum_black_svc",
    SUM_HHIHGHSVCA: "sum_hhihghsvca",
    SUM_HHILOWSVCA: "sum_hhilowsvca",
    SUM_HHIMEDSVCA: "sum_hhimedsvca",
    SUM_HISP: "sum_hisp",
    SUM_HISP_SVC: "sum_hisp_svc",
    SUM_KIDS: "sum_kids",
    SUM_KIDS_SVCA: "sum_kids_svca",
    SUM_OTHRACE: "sum_othrace",
    SUM_OTHRACESVC: "sum_othracesvc",
    SUM_PACIFIC: "sum_pacific",
    SUM_PACIFICSVC: "sum_pacificsvc",
    SUM_RACE2UP: "sum_race2up",
    SUM_RACE2UPSVC: "sum_race2upsvc",
    SUM_SENIORS: "sum_seniors",
    SUM_SENIORS_SVCA: "sum_seniors_svca",
    SUM_SVCAREA: "sum_svcarea",
    SUM_TOTPOPSVCA: "sum_totpopsvca",
    SUM_TPL_TOT_POP: "sum_tpl_tot_pop",
    SUM_TPL_TOTHH: "sum_tpl_tothh",
    SUM_TPLHHIHGH: "sum_tplhhihgh",
    SUM_TPLHHILOW: "sum_tplhhilow",
    SUM_TPLHHIMED: "sum_tplhhimed",
    SUM_UA_AMERIND: "sum_ua_amerind",
    SUM_UA_ASIAN: "sum_ua_asian",
    SUM_UA_BLACK: "sum_ua_black",
    SUM_UA_HISP: "sum_ua_hisp",
    SUM_UA_KIDS: "sum_ua_kids",
    SUM_UA_OTHRACE: "sum_ua_othrace",
    SUM_UA_PACIFIC: "sum_ua_pacific",
    SUM_UA_RACE2UP: "sum_ua_race2up",
    SUM_UA_SENIORS: "sum_ua_seniors",
    SUM_UA_TPLHHIHGH: "sum_ua_tplhhihgh",
    SUM_UA_TPLHHILOW: "sum_ua_tplhhilow",
    SUM_UA_TPLHHIMED: "sum_ua_tplhhimed",
    SUM_UA_WHITE: "sum_ua_white",
    SUM_UA_YOUNG_PRO: "sum_ua_young_pro",
    SUM_WHITE: "sum_white",
    SUM_WHITE_SVC: "sum_white_svc",
    SUM_YOUNG_PRO: "sum_young_pro",
    SUM_YOUNG_PRO_SVCA: "sum_young_pro_svca",
    TestLowinc: "testlowinc",
    Total_City_Acreage: "total_city_acreage",
    Total_Park_Acreage: "total_park_acreage",
    Total_Parkland_Pct: "total_parkland_pct",
    TOTAL_POP: "total_pop",
    TotPop_Per_ParkAcre: "totpop_per_parkacre",
    UA_ID: "ua_id",
    UA_ID_UA: "ua_id_ua",
    UA_MedianIncome_2019: "ua_medianincome_2019",
    Website_StatsDisplay: "website_statsdisplay",

    trails_YN: "trails_yn",
    ParkID: "parkid",
    Park_Name: "park_name",
    Park_Designation: "park_designation",
    Park_Local_Owner: "park_local_owner",
    Park_Local_Manager: "park_local_manager",
    Park_Access: "park_access",
    Park_Size_Acres: "park_size_acres",
    Park_Address_1: "park_address_1",
    Park_UrbanArea: "park_urbanarea",
    Park_UrbanArea_ID: "park_urbanarea_id",
    SUM_KIDSVCA: "sum_kidsvca",
    SUM_YOUNGPROSVCA: "sum_youngprosvca",
    SUM_SENIORSVCA: "sum_seniorsvca",
    SUM_HHIHIGHSVCA: "sum_hhihighsvca",
    SUM_TOTHHSVCA: "sum_tothhsvca",
    playground_count: "playground_count",
    canopy_pct: "canopy_pct",
    DataShare_YN: "datashare_yn",
    Park_Place: "park_place",
    Park_Place_FIPS: "park_place_fips",
    GISTrkrID: "gistrkrid",
    SourceID: "sourceid",
    Park_Owner_Type: "park_owner_type",
    Park_Manager_Type: "park_manager_type",
    Park_Status: "park_status",
    Park_Land_Acquisition: "park_land_acquisition",
    Park_Est_Date: "park_est_date",
    Park_Size_SQFT: "park_size_sqft",
    Park_Size_SQMeters: "park_size_sqmeters",
    Park_State: "park_state",
    Park_State_FIPS: "park_state_fips",
    Park_County: "park_county",
    Park_County_FIPS: "park_county_fips",
    Park_Zip: "park_zip",
    Park_Boundary_Source: "park_boundary_source",
    Park_Source_Agency: "park_source_agency",
    Park_Feedback_Source: "park_feedback_source",
    Park_DateAdded: "park_dateadded",
    area_sq_km: "area_sq_km",

    ParkPriority: "parkpriority",
    CITY_FIPS: "city_fips",
    TPL_Acres: "tpl_acres",
    PopPerAcre: "popperacre",
    ERASEAREA: "erasearea",
    LPA_double: "lpa_double",
    Mental_double: "mental_double",
    RESP: "resp",
    LowInc_Dens: "lowinc_dens",
    POC_Dens: "poc_dens",
    UrbanAreaIDPlace: "urbanareaidplace",
    LowIncPerc: "lowincperc",
    POCPerc: "pocperc",
    PPARank: "pparank",
    LPARank: "lparank",
    MentalRank: "mentalrank",
    HeatRank: "heatrank",
    RESPRank: "resprank",
    POCDensRank: "pocdensrank",
    POCPercRank: "pocpercrank",
    LowIncPercRank: "lowincpercrank",
    LowIncDensRank: "lowincdensrank",
    HealthFloat: "healthfloat",
    ParkRank: "parkrank",
    BGID_PlaceID: "bgid_placeid",
    UHI_Anomaly: "uhi_anomaly",
    Outside10MWOnly: "outside10mwonly",
    ParkNeed_UserWeights: "parkneed_userweights",
    ParkNeed: "parkneed",

    Health_Float: "health_float",
    LowIncRank: "lowincrank",
    RG_NAME: "rg_name",
    RG_ABBREV: "rg_abbrev",
    UHI_UrbanAnomaly: "uhi_urbananomaly",
    TPLHHILOW: "tplhhilow",
    POCRank: "pocrank"
}

export const placeSearchField: string = dataFields["Place_StAbbrev"];
export const placeIdField: string = dataFields["ID"];
export const placeServiceIdField: string = dataFields["PLACE_ID"];
export const urbanIdField: string = dataFields["ParkServe_UrbanArea_ID"];
export const placeObjectIdField: string = dataFields["OBJECTID"];

//export const totalNumberParks: string = "";
//export const totalAcresOfParks: string = "";

// Feature layer objects
export const placeServiceLayer = new FeatureLayer({
  url: placeServiceURL,
});

export const urbanAreaLayer = new FeatureLayer({
  url: urbanAreaURL,
});


// Prioritization symbology colors
export const customPrioritizationLayerColors = {
  veryHigh: "#8c05fa",
  high: "#a339fa",
  moderate: "#c482fa",
};

// Feature labels
export const parkLabels: any = {
  ACC: "Access Area",
  ACEC: "Area of Critical Environmental Concern",
  AGRE: "Agricultural Easement",
  CONE: "Conservation Easement",
  FORE: "Forest Stewardship Easement",
  FOTH: "Federal Other or Unknown",
  HCA: "Historic or Cultural Area",
  HCAE: "Historic or Cultural Easement",
  IRA: "Inventoried Roadless Area",
  LCA: "Local Conservation Area",
  LHCA: "Local Historic or Cultural Area",
  LOTH: "Local Other or Unknown",
  LP: "Local Park",
  LREC: "Local Recreation Area",
  LRMA: "Local Resource Management Area",
  MIL: "Military Land",
  MIT: "Mitigation Land or Bank",
  MPA: "Marine Protected Area",
  NCA: "National Conservation Area",
  ND: "Not Designated",
  NF: "National Forest",
  NG: "National Grassland",
  NLS: "National Lakeshore or Seashore",
  NM: "National Monument or Landmark",
  NP: "National Park",
  NRA: "National Recreation Area",
  NSBV: "National Scenic, Botanical or Volcanic Area",
  NT: "National Scenic or Historic Trail",
  NWR: "National Wildlife Refuge",
  OTHE: "Other Easement",
  PAGR: "Private Agricultural",
  PCON: "Private Conservation",
  PFOR: "Private Forest Stewardship",
  PHCA: "Private Historic or Cultural ",
  POTH: "Private Other or Unknown",
  PPRK: "Private Park",
  PRAN: "Private Ranch",
  PREC: "Private Recreation or Education",
  PROC: "Approved or Proclamation Boundary",
  PUB: "National Public Lands",
  RANE: "Ranch Easement",
  REA: "Research or Educational Area",
  REC: "Recreation Management Area",
  RECE: "Recreation or Education Easement",
  RMA: "Resource Management Area",
  RNA: "Research Natural Area",
  SCA: "State Conservation Area",
  SDA: "Special Designation Area",
  SHCA: "State Historic or Cultural Area",
  SOTH: "State Other or Unknown",
  SP: "State Park",
  SREC: "State Recreation Area",
  SRMA: "State Resource Management Area",
  SW: "State Wilderness",
  TRIBL: "Native American Land",
  UNK: "Unknown",
  UNKE: "Unknown Easement",
  WA: "Wilderness Area",
  WPA: "Watershed Protection Area",
  WSA: "Wilderness Study Area",
  WSR: "Wild and Scenic River",
};

// Statistics constants
export const totalNumberParks: string = "";
export const totalAcresOfParks: string = "";
export const nationalStats: any = {
  popWithin10minWalk: 137481379,
  popOutside10minWalk: 108280497,
  totalUSPop: 245761876,
  totalParks: "136K",
  totalParkAcres: "160M",
  PercentPopWithin: {
    total: 55.9,
    kids: 55.7,
    adults: 56.7,
    seniors: 53.6,
    lowIncomeHouse: 60.1,
    medIncomeHouse: 57.0,
    highIncomeHouse: 52.8,
    white: 51.9,
    black: 58.1,
    nativeAmerican: 56.2,
    asian: 63.8,
    pacificIslander: 62.2,
    other: 63.4,
    twoOrMore: 58.3,
    hispanic: 61.2,
  },
  TotalPopWithin: {
    total: 137481379,
    kids: 33941810,
    adults: 81910587,
    seniors: 21628986,
    lowIncomeHouse: 19778526,
    medIncomeHouse: 12401785,
    highIncomeHouse: 20282578,
    white: 66911792,
    black: 20570171,
    nativeAmerican: 646206,
    asian: 11520390,
    pacificIslander: 313879,
    other: 348297,
    twoOrMore: 3764196,
    hispanic: 33406268,
  },
  totalPopOutside: {
    total: 108280497,
    kids: 26967811,
    adults: 62581876,
    seniors: 18732561,
    lowIncomeHouse: 13150567,
    medIncomeHouse: 9341120,
    highIncomeHouse: 18112792,
    white: 62111416,
    black: 14847180,
    nativeAmerican: 503576,
    asian: 6537635,
    pacificIslander: 191049,
    other: 200953,
    twoOrMore: 2692589,
    hispanic: 21194284,
  },
};

// Chart configuration
export const chartColors = [
  "#E7F4B8",
  "#BEDA58",
  "#5DBA54",
  "#1D8363",
  "#57C5F8",
  "#2EA0D4",
  "#1989BC",
];

export const incomeLabels = [
  "Low Income (<75% MAI)",
  "Medium Income (75%-125% MAI)",
  "High income (>125% MAI)",
];

export const demoLabels = [
  "White*",
  "Black*",
  "Native American*",
  "Asian*",
  "Pacific Islander*",
  "Other Race*",
  "Two or More Races*",
  "Hispanic",
];

export const ageLabels = ["Youth (<20)", "Adults (20-64)", "Seniors (>64)"];

export const incomeGroupInServiceArea: any = [
  {
    displayName: "Low Income (<75% MAI)",
    value: "SUM_HHILOWSVCA",
    total: "SUM_TPLHHILOW",
    amount: 0,
  },
  {
    displayName: "Medium Income (75%-125% MAI)",
    value: "SUM_HHIMEDSVCA",
    total: "SUM_TPLHHIMED",
    amount: 0,
  },
  {
    displayName: "High income (>125% MAI)",
    value: "SUM_HHIHGHSVCA",
    total: "SUM_TPLHHIHGH",
    amount: 0,
  },
];

export const ageGroupInServiceArea: any = [
  {
    displayName: "Youth (<20)",
    value: "SUM_KIDS_SVCA",
    total: "SUM_KIDS",
    amount: 0,
  },
  {
    displayName: "Adults (20-64)",
    value: "SUM_YOUNG_PRO_SVCA",
    total: "SUM_YOUNG_PRO",
    amount: 0,
  },
  {
    displayName: "Seniors (>64)",
    value: "SUM_SENIORS_SVCA",
    total: "SUM_SENIORS",
    amount: 0,
  },
];

export const demographicsInServiceArea: any = [
  {
    displayName: "White*",
    value: "SUM_WHITE_SVC",
    total: "SUM_WHITE",
    amount: 0,
  },
  {
    displayName: "Black*",
    value: "SUM_BLACK_SVC",
    total: "SUM_BLACK",
    amount: 0,
  },
  {
    displayName: "Native American*",
    value: "SUM_AMERINDSVC",
    total: "SUM_AMERIND",
    amount: 0,
  },
  {
    displayName: "Asian*",
    value: "SUM_ASIAN_SVC",
    total: "SUM_ASIAN",
    amount: 0,
  },
  {
    displayName: "Pacific Islander*",
    value: "SUM_PACIFICSVC",
    total: "SUM_PACIFIC",
    amount: 0,
  },
  {
    displayName: "Other Race*",
    value: "SUM_OTHRACESVC",
    total: "SUM_OTHRACE",
    amount: 0,
  },
  {
    displayName: "Two or More Races*",
    value: "SUM_RACE2UPSVC",
    total: "SUM_RACE2UP",
    amount: 0,
  },
  {
    displayName: "Hispanic",
    value: "SUM_HISP_SVC",
    total: "SUM_HISP",
    amount: 0,
  },
];

export const chartOnHover: any = [
  {
    displayName: "White*",
    value: "SUM_WHITE_SVC",
    total: "SUM_WHITE",
    amount: 0,
  },
  {
    displayName: "Black*",
    value: "SUM_BLACK_SVC",
    total: "SUM_BLACK",
    amount: 0,
  },
  {
    displayName: "Native American*",
    value: "SUM_AMERINDSVC",
    total: "SUM_AMERIND",
    amount: 0,
  },
  {
    displayName: "Asian*",
    value: "SUM_ASIAN_SVC",
    total: "SUM_ASIAN",
    amount: 0,
  },
  {
    displayName: "Pacific Islander*",
    value: "SUM_PACIFICSVC",
    total: "SUM_PACIFIC",
    amount: 0,
  },
  {
    displayName: "Other Race*",
    value: "SUM_OTHRACESVC",
    total: "SUM_OTHRACE",
    amount: 0,
  },
  {
    displayName: "Two or More Races*",
    value: "SUM_RACE2UPSVC",
    total: "SUM_RACE2UP",
    amount: 0,
  },
  {
    displayName: "Hispanic",
    value: "SUM_HISP_SVC",
    total: "SUM_HISP",
    amount: 0,
  },
  {
    displayName: "Youth (<20)",
    value: "SUM_KIDS_SVCA",
    total: "SUM_KIDS",
    amount: 0,
  },
  {
    displayName: "Adults (20-64)",
    value: "SUM_YOUNG_PRO_SVCA",
    total: "SUM_YOUNG_PRO",
    amount: 0,
  },
  {
    displayName: "Seniors (>64)",
    value: "SUM_SENIORS_SVCA",
    total: "SUM_SENIORS",
    amount: 0,
  },
  {
    displayName: "Low Income (<75% MAI)",
    value: "SUM_HHILOWSVCA",
    total: "SUM_TPLHHILOW",
    amount: 0,
  },
  {
    displayName: "Medium Income (75%-125% MAI)",
    value: "SUM_HHIMEDSVCA",
    total: "SUM_TPLHHIMED",
    amount: 0,
  },
  {
    displayName: "High income (>125% MAI)",
    value: "SUM_HHIHGHSVCA",
    total: "SUM_TPLHHIHGH",
    amount: 0,
  },
];
